// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"8c3716b6","621":"00f2b296","950":"11f76502"}[chunkId] + ".chunk.js";
};